import { Component, signal, inject } from '@angular/core';
import { SwiperDirective } from '../../shared/directive/swiper.directive';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarService } from '../../pages/blog/sidebar/Services/Sidebar.service';
import { LatestPosts } from './Model/Blogs.model';
import { CommonModule, DatePipe, SlicePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { BlogFilter } from '../../pages/blog/blogs/Model/Posts.model';

@Component({
  selector: 'app-blog-slider',
  imports: [SwiperDirective, TranslateModule, DatePipe, RouterLink, SlicePipe, CommonModule],
  templateUrl: './blog-slider.component.html',
  styleUrl: './blog-slider.component.css'
})
export class BlogSliderComponent {

  LatestPosts = signal<LatestPosts[]>([]);
  private subs = new Subscription();   // container for all subscriptions
  filter: any;

  public swiperOptions = signal({
    slidesPerView: 4,
    spaceBetween: 30,
    items: 3,
    speed: 1500,
    loop: true,
    loopFillGroupWithBlank: true,
    centeredSlides: false,
    breakpoints: {
      1600: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 3,
      },
      1220: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
      900: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },

    },
    autoplay: {
      delay: 2500,
      // disableOnInteraction: true
      pauseOnMouseEnter: true,
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      // type: "fraction",
      type: "bullets",
    }
  })

  private SidebarService = inject(SidebarService);

  ngOnInit(): void {
    this.getLatestPosts();
  }

  getLatestPosts() {
    let filter: BlogFilter = { PostType: 'Post' }
    const sub = this.SidebarService.getLatestPosts(filter).subscribe({
      next: (data: any) => {
        this.LatestPosts.set(data.value);
        // console.log(this.LatestPosts());

      },
      error: (err) => {
        console.error('Error loading sliders:', err);
      }
    });
    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}
